var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRedo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.0291 0.879073C5.88507 0.751767 5.65821 0.854026 5.65821 1.04625V3.2799C2.85149 3.59807 0.726566 6.11717 0.919099 9.00517C0.934698 9.23916 1.25496 9.30154 1.34733 9.086L1.62468 8.43885C2.0466 7.45438 3.01462 6.81607 4.08569 6.81607H5.65821V8.98124C5.65821 9.17347 5.88507 9.27573 6.0291 9.14842L10.5178 5.18093C10.6183 5.09212 10.6183 4.93537 10.5178 4.84657L6.0291 0.879073Z",
    fill: "#BCBCBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRedo);
export default __webpack_public_path__ + "static/media/icon-redo.ac58c713ada539317ed08853e5d3a30e.svg";
export { ForwardRef as ReactComponent };